import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
/** Block 1 / CW-005 — client clarification request/response (candidate evidence only). */
export const ClarificationRequestKindSchema = z.enum([
    "MISSING_INFORMATION",
    "UNCERTAIN_INFORMATION",
    "CLARIFICATION_REQUESTED",
]);
export const ClarificationRequestStatusSchema = z.enum([
    "OPEN",
    "SUBMITTED",
    "PENDING_REVIEW",
    "RESOLVED",
    "REJECTED",
    "STALE",
]);
export const ClarificationRequestIdSchema = z
    .string()
    .regex(/^clrq_[a-zA-Z0-9_-]+$/)
    .brand();
export const ClarificationRequestV1Schema = z
    .object({
    schemaVersion: z.literal("clarification-request.v1.0"),
    clarificationRequestId: ClarificationRequestIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    kind: ClarificationRequestKindSchema,
    status: ClarificationRequestStatusSchema,
    prompt: z.string().min(1).max(2000),
    fieldPath: z.string().min(1).max(200).optional(),
    responseText: z.string().min(1).max(4000).optional(),
    lifecycleVersion: z.number().int().min(0),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    submittedAt: z.string().datetime().optional(),
    resolvedAt: z.string().datetime().optional(),
})
    .strict();
export const ClarificationCreateRequestV1Schema = z
    .object({
    schemaVersion: z.literal("clarification-create.v1.0"),
    kind: ClarificationRequestKindSchema,
    prompt: z.string().min(1).max(2000),
    fieldPath: z.string().min(1).max(200).optional(),
})
    .strict();
export const ClarificationRespondRequestV1Schema = z
    .object({
    schemaVersion: z.literal("clarification-respond.v1.0"),
    responseText: z.string().min(1).max(4000),
    expectedLifecycleVersion: z.number().int().min(0),
})
    .strict();
export const ClarificationListV1Schema = z
    .object({
    schemaVersion: z.literal("clarification-list.v1.0"),
    items: z.array(ClarificationRequestV1Schema),
})
    .strict();
export const ClarificationActionResultV1Schema = z
    .object({
    schemaVersion: z.literal("clarification-action-result.v1.0"),
    ok: z.boolean(),
    request: ClarificationRequestV1Schema.optional(),
    error: z
        .enum([
        "not_found",
        "tenant_mismatch",
        "project_mismatch",
        "permission_denied",
        "validation_failed",
        "stale_request",
        "invalid_status",
        "network_or_server_error",
        "audit_append_failed",
    ])
        .optional(),
    nextAction: z.string().min(1).max(200).optional(),
})
    .strict();
//# sourceMappingURL=clarification.js.map